var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3c0 1.4-1.1 2.5-2.5 2.5S7.5 4.4 7.5 3 8.6.5 10 .5s2.5 1.1 2.5 2.5zM12.5 10c0 1.4-1.1 2.5-2.5 2.5S7.5 11.4 7.5 10 8.6 7.5 10 7.5s2.5 1.1 2.5 2.5zM10 19.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z"
  })));
};
export default SvgThreeDots;